import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Auth
export const registerAuthService = (data) => {
  return http.post(`${base_url}/auth/register`, data);
};
export const confirmRegisterAuthService = (data, token) => {
  return http.patch(`${base_url}/auth/register/confirm`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const loginAuthService = (data) => {
  return http.post(`${base_url}/auth/login`, data);
};
export const sendLoginOTPAuthService = (data) => {
  return http.patch(`${base_url}/auth/login/otp/send`, data);
};
export const verifyLoginOTPAuthService = (data) => {
  return http.post(`${base_url}/auth/login/otp/verify`, data);
};
export const forgotPasswordAuthService = (data) => {
  return http.put(`${base_url}/auth/forgot-password`, data);
};
// End Auth

// Start OTP
export const sendPhoneNumberOTPUserService = (data) => {
  return http.post(`${base_url}/user/phone-number/otp/send`, data);
};
export const verifyPhoneNumberOTPUserService = (data) => {
  return http.patch(`${base_url}/user/phone-number/otp/verify`, data);
};
export const sendEmailOTPUserService = (data) => {
  return http.post(`${base_url}/user/email/otp/send`, data);
};
export const verifyEmailOTPUserService = (data) => {
  return http.patch(`${base_url}/user/email/otp/verify`, data);
};
// End OTP

// Start Change Password
export const changePasswordAuthService = (data) => {
  return http.post(`${base_url}/user/change-password`, data);
};
// End Change Password

// Start Info
export const getInfoUserService = () => {
  return http.get(`${base_url}/user/info`);
};
export const editInfoUserService = (data) => {
  return http.put(`${base_url}/user/info`, data);
};
// End Info

// Start Upload
export const uploadUserService = (data, params) => {
  return http.post(`${base_url}/user/upload`, data, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
// End Upload

// End Order
export const getOrdersUserService = (params) => {
  return http.get(`${base_url}/user/orders`, { params });
};
// End Order
